exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subscription_from_balance[data-v-41dab38a]{display:flex;flex-direction:column;align-items:center}.header[data-v-41dab38a]{align-self:flex-start}.explanation[data-v-41dab38a]{margin-top:0}.email[data-v-41dab38a]{margin-top:10px;text-align:center}.email_value[data-v-41dab38a]{font-weight:700}.button[data-v-41dab38a]{margin-top:15px;margin-left:0}.success[data-v-41dab38a]{margin-top:15px;font-size:17px;text-align:center}", ""]);

// exports
